var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 76,
    viewBox: "0 0 69 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.95 19.48L65.43 19.04C65.43 17.95 65.43 16.86 65.21 15.99L66.73 15.34C67.17 15.12 67.38 14.69 67.17 14.25L66.73 13.16C66.51 12.72 66.08 12.51 65.64 12.72L64.33 13.16C63.89 12.29 63.24 11.2 62.59 10.33L63.68 9.24C63.9 8.8 63.9 8.37 63.68 8.15L62.81 7.28C62.37 7.06 61.94 7.06 61.72 7.28L60.63 8.37C59.76 7.72 58.67 7.28 57.58 6.85L57.8 5.33C57.8 4.89 57.58 4.46 57.15 4.24L55.84 4.02C55.4 4.02 54.97 4.24 54.75 4.67L54.53 6.41C53.44 6.19 52.13 6.41 51.05 6.63L50.4 5.11C50.18 4.67 49.75 4.46 49.31 4.46L48 4.89C47.56 5.11 47.35 5.54 47.56 5.98L48.21 7.5C47.12 7.94 46.03 8.59 45.16 9.46L43.85 8.37C43.41 7.93 42.76 8.15 42.54 8.37L41.67 9.24C41.45 9.68 41.45 10.11 41.67 10.55L43.19 11.86C42.54 12.73 42.1 13.82 41.67 14.91L39.71 14.47C39.27 14.47 38.62 14.69 38.62 15.12L38.4 16.43C38.4 16.87 38.62 17.3 39.27 17.52L41.23 17.96C41.23 19.05 41.23 20.36 41.67 21.44L39.71 22.09C39.27 22.31 39.06 22.74 39.06 23.18L39.5 24.49C39.72 24.93 40.15 25.14 40.81 24.93L42.77 24.28C43.21 25.15 44.08 26.24 44.73 26.89L43.42 28.41C43.2 28.85 43.2 29.28 43.42 29.72L44.51 30.59C44.95 30.81 45.38 30.81 45.82 30.37L47.13 28.85C48 29.29 49.09 29.72 50.18 30.16L49.74 32.12C49.74 32.56 49.96 32.99 50.39 32.99L51.7 33.21C52.14 33.21 52.57 32.99 52.79 32.56L53.23 30.6C54.32 30.6 55.41 30.38 56.5 30.16L57.15 31.9C57.37 32.34 57.8 32.55 58.24 32.34L59.33 31.9C59.77 31.68 59.98 31.25 59.77 30.81L58.9 28.63C59.77 28.19 60.64 27.54 61.51 26.89L62.82 27.98C63.04 28.2 63.69 28.2 63.91 27.76L64.78 26.89C65 26.45 65 26.02 64.78 25.8L63.47 24.71C64.12 23.84 64.56 22.97 64.78 21.88L66.52 22.1C66.96 22.1 67.39 21.88 67.39 21.45L67.61 20.36C67.6 19.92 67.39 19.48 66.95 19.48ZM52.36 26.45C47.57 25.8 44.3 21.44 45.17 16.65C46.04 11.86 50.61 9.03 55.41 9.9C59.98 10.99 62.82 15.34 61.94 19.7C61.06 24.06 56.93 27.1 52.36 26.45Z",
    fill: "#97A6B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0501 4.45L49.7501 4.24L49.3101 5.11L51.0501 4.45Z",
    fill: "#97A6B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.16 7.07L63.47 7.28L63.25 8.37L62.16 7.07Z",
    fill: "#97A6B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3 12.73L67.6 12.95L67.17 13.6L66.3 12.73Z",
    fill: "#97A6B7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.17 19.48L68.48 19.7L67.82 20.35L67.17 19.48Z",
    fill: "#97A6B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 28.19L64.56 28.63L64.77 27.54L63.25 28.19Z",
    fill: "#97A6B7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.37 31.9L58.46 32.33L58.89 31.46L57.37 31.9Z",
    fill: "#97A6B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2701 32.77L50.1801 32.55L51.4901 31.24L51.2701 32.77Z",
    fill: "#97A6B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.83 30.81L44.74 30.15L45.83 29.28V30.81Z",
    fill: "#97A6B7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.21 7.94L44.52 8.16L43.65 9.03L43.21 7.94Z",
    fill: "#97A6B7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.86 17.3L39.94 17.74V16.65L38.86 17.3Z",
    fill: "#97A6B7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9401 24.49L41.0301 24.93L41.2501 24.27L39.9401 24.49Z",
    fill: "#97A6B7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.26 19.7L66.74 19.48C66.74 18.39 66.74 17.3 66.52 16.21L68.04 15.77C68.48 15.55 68.69 15.12 68.48 14.68L68.04 13.59C68.04 13.15 67.6 12.94 67.17 12.94L65.65 13.38C65.21 12.29 64.56 11.42 63.91 10.55L65 9.46C65.22 9.02 65.22 8.59 65 8.37L64.12 7.5C63.68 7.28 63.25 7.28 63.03 7.5L61.72 8.81C60.85 8.16 59.76 7.72 58.67 7.29L58.89 5.55C58.89 5.11 58.67 4.68 58.24 4.46L56.93 4.24C56.49 4.24 56.06 4.46 55.84 4.89V6.63C54.75 6.41 53.44 6.63 52.36 6.85L51.71 5.33C51.49 4.89 51.06 4.68 50.62 4.68L49.31 5.12C48.87 5.34 48.66 5.77 48.87 6.21L49.52 7.73C48.43 8.17 47.34 8.82 46.47 9.69L45.16 8.6C44.72 8.16 44.07 8.38 43.85 8.6L42.98 9.47C42.54 9.91 42.76 10.34 42.98 10.78L44.5 12.09C43.85 12.96 43.41 14.05 42.98 15.14L41.02 14.7C40.58 14.7 39.93 14.92 39.93 15.35L39.71 16.66C39.71 17.1 39.93 17.53 40.58 17.75L42.54 18.19C42.54 19.28 42.54 20.59 42.98 21.67L41.02 22.32C40.58 22.54 40.15 22.97 40.37 23.41L40.81 24.72C41.03 25.16 41.46 25.37 42.12 25.16L44.08 24.51C44.52 25.38 45.39 26.47 46.04 27.12L44.52 28.43C44.3 28.87 44.3 29.3 44.52 29.74L45.61 30.61C46.05 30.83 46.48 30.83 46.92 30.39L48.23 28.87C49.1 29.31 50.19 29.74 51.28 30.18L50.84 32.14C50.84 32.58 51.06 33.01 51.49 33.01L52.8 33.23C53.24 33.23 53.67 33.01 53.89 32.58L54.33 30.62C55.42 30.62 56.51 30.4 57.6 30.18L58.25 31.92C58.47 32.36 58.9 32.57 59.34 32.36L60.43 31.92C60.87 31.7 61.08 31.27 60.87 30.83L60.22 29.09C61.09 28.65 61.96 28 62.83 27.35L64.14 28.44C64.36 28.66 65.01 28.66 65.23 28.22L66.1 27.35C66.32 26.91 66.32 26.48 66.1 26.26L64.79 25.17C65.44 24.3 65.88 23.43 66.1 22.34L67.84 22.56C68.28 22.56 68.71 22.34 68.71 21.91L68.93 20.82C68.91 20.13 68.69 19.7 68.26 19.7ZM53.45 26.89C48.66 26.24 45.39 21.66 46.26 16.87C47.13 12.08 51.92 9.03 56.71 10.12C61.28 10.99 64.33 15.56 63.46 19.92C62.38 24.49 58.02 27.54 53.45 26.89Z",
    fill: "#D8DEE8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.43 61.3L20.34 61.08C20.34 60.21 20.34 59.56 20.12 58.68L21.21 58.24C21.43 58.24 21.65 57.8 21.65 57.37L21.43 56.72C21.21 56.5 20.99 56.28 20.78 56.28L19.47 56.72C19.03 56.07 18.6 55.2 18.16 54.76L19.03 53.89C19.25 53.67 19.25 53.24 19.03 53.02L18.16 52.37C17.94 52.15 17.51 52.15 17.29 52.37L16.64 53.24C15.99 52.8 15.12 52.37 14.46 52.15L14.68 51.06C14.68 50.62 14.46 50.41 14.24 50.19L13.15 49.97C12.71 49.97 12.5 50.19 12.5 50.41L12.28 51.5C11.41 51.5 10.54 51.5 9.66998 51.5L9.22997 50.41C9.00997 50.19 8.57998 49.97 8.35997 50.19L7.48998 50.41C7.04998 50.41 7.04998 50.85 7.04998 51.28L7.48998 52.37C6.61998 52.81 5.96998 53.24 5.30998 53.68L4.22998 52.8C4.00998 52.58 3.57998 52.58 3.13998 52.8L2.48998 53.45C2.26998 54.1 2.26998 54.54 2.48998 54.76L3.57998 55.63C3.13998 56.28 2.70998 57.15 2.48998 58.03L0.969976 57.81C0.529976 57.81 0.319976 58.03 0.0999756 58.25V59.12C0.0999756 59.56 0.319976 59.77 0.749976 59.99L2.26998 60.21C2.26998 61.08 2.26998 61.95 2.48998 62.82L0.969976 63.26C0.529976 63.48 0.319976 63.7 0.529976 64.13L0.959976 65C1.17998 65.22 1.60998 65.44 1.82998 65.44L3.35998 65C3.79998 65.65 4.22998 66.31 4.87998 66.96L3.78998 68.05C3.56998 68.27 3.56998 68.7 3.78998 68.92L4.43998 69.57C4.65998 69.79 5.08998 69.79 5.30998 69.57L6.61998 68.26C7.26998 68.7 8.13998 68.91 8.79998 69.13L8.57998 70.65C8.57998 71.09 8.79998 71.3 9.01998 71.3H9.88998C10.33 71.3 10.54 71.08 10.54 70.86L10.76 69.34C11.63 69.34 12.28 69.34 13.16 69.12L13.6 70.43C13.82 70.65 14.04 70.87 14.47 70.87L15.34 70.43C15.78 70.21 15.78 69.99 15.78 69.56L15.34 68.25C16.21 68.03 16.86 67.6 17.52 66.94L18.61 67.81C18.83 68.03 19.26 68.03 19.48 67.81L20.13 67.16C20.35 66.94 20.35 66.51 20.13 66.29L18.82 65.42C19.26 64.77 19.69 64.11 19.91 63.24L21.22 63.46C21.44 63.46 21.87 63.24 21.87 63.02L22.09 62.15C22.09 61.95 21.87 61.52 21.43 61.3ZM10.54 66.74C7.05998 66.3 4.43998 62.82 5.09998 59.33C5.75998 55.84 9.23997 53.67 12.72 54.32C16.2 54.97 18.38 58.24 17.73 61.51C17.08 65 14.03 67.18 10.54 66.74Z",
    fill: "#97A6B7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45002 50.19H8.58002L8.15002 50.84L9.45002 50.19Z",
    fill: "#97A6B7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.73 52.15L18.82 52.37L18.6 53.24L17.73 52.15Z",
    fill: "#97A6B7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21 56.51L21.87 56.72L21.65 57.16L21 56.51Z",
    fill: "#97A6B7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.65 61.52L22.52 61.73L22.09 62.17L21.65 61.52Z",
    fill: "#97A6B7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 67.83L19.69 68.27L19.91 67.4L18.6 67.83Z",
    fill: "#97A6B7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.24 70.66L15.12 71.1L15.33 70.45L14.24 70.66Z",
    fill: "#97A6B7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67002 71.53L9.02002 71.1L9.89002 70.23L9.67002 71.53Z",
    fill: "#97A6B7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 69.79L4.88 69.57L5.75 68.7V69.79Z",
    fill: "#97A6B7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56995 52.8L4.65995 53.02L4.22995 53.67L3.56995 52.8Z",
    fill: "#97A6B7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0.52002 59.77L1.18002 59.99L1.40002 59.34L0.52002 59.77Z",
    fill: "#97A6B7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40002 65.22L2.05002 65.65L2.27002 65L1.40002 65.22Z",
    fill: "#97A6B7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.52 61.73L21.21 61.51C21.21 60.64 21.21 59.99 20.99 59.11L22.08 58.67C22.3 58.67 22.52 58.23 22.52 57.8L22.3 56.93C22.3 56.71 21.86 56.49 21.65 56.71L20.56 57.15C20.12 56.5 19.69 55.63 19.25 54.97L20.12 54.1C20.34 53.88 20.34 53.45 20.12 53.23L19.47 52.58C19.25 52.36 18.82 52.36 18.6 52.58L17.51 53.45C16.86 53.01 15.99 52.58 15.33 52.36L15.55 51.27C15.55 50.83 15.33 50.62 15.11 50.4L14.02 50.18C13.58 50.18 13.37 50.4 13.37 50.62L13.15 51.71C12.28 51.71 11.41 51.71 10.54 51.71L10.1 50.62C9.88 50.18 9.66 50.18 9.23 50.18L8.36 50.4C7.92 50.4 7.92 50.84 7.92 51.27L8.36 52.58C7.49 53.02 6.84 53.45 6.18 54.1L5.1 53.24C4.88 53.02 4.45 53.02 4.01 53.24L3.36 53.89C3.14 54.11 3.14 54.54 3.36 54.76L4.45 55.85C4.01 56.5 3.58 57.37 3.36 58.25L1.84 58.03C1.4 58.03 1.19 58.25 0.97 58.47L0.75 59.56C0.75 60 0.97 60.21 1.4 60.43L2.92 60.65C2.92 61.52 2.92 62.39 3.14 63.26L1.62 63.7C1.18 63.92 0.97 64.14 1.18 64.57L1.62 65.44C1.84 65.88 2.27 65.88 2.49 65.88L4.01 65.44C4.45 66.09 4.88 66.75 5.53 67.4L4.44 68.49C4.22 68.71 4.22 69.14 4.44 69.36L5.53 69.8C5.75 70.02 6.18 70.02 6.4 69.8L7.49 68.71C8.14 69.15 9.01 69.36 9.89 69.58L9.67 71.1C9.67 71.54 9.89 71.75 10.11 71.75H10.98C11.42 71.75 11.63 71.53 11.63 71.31L11.85 69.79C12.72 69.79 13.59 69.79 14.25 69.57L14.69 70.88C14.91 71.32 15.13 71.32 15.56 71.32L16.43 70.88C16.87 70.66 16.87 70.44 16.87 70.01L16.43 68.7C17.08 68.26 17.74 67.83 18.39 67.39L19.48 68.26C19.7 68.48 20.13 68.48 20.35 68.26L21 67.61C21.22 67.39 21.22 66.96 21 66.74L19.69 65.65C20.13 65 20.56 64.34 20.78 63.47L22.09 63.69C22.31 63.69 22.74 63.47 22.74 63.25L22.96 62.38C22.96 62.17 22.74 61.73 22.52 61.73ZM11.41 66.96C7.71 66.52 5.31 63.04 5.97 59.55C6.63 56.06 10.11 53.67 13.59 54.54C17.07 55.19 19.25 58.46 18.6 61.95C18.17 65.22 14.9 67.61 11.41 66.96Z",
    fill: "#D8DEE8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.73 6.63L15.33 6.85C15.33 3.58 17.51 0.750001 20.34 0.750001H22.74C19.91 0.530001 17.73 3.36 17.73 6.63Z",
    fill: "url(#paint0_linear_239_370)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.73 6.63L15.33 6.85C15.33 3.58 17.51 0.750001 20.34 0.750001H22.74C19.91 0.530001 17.73 3.36 17.73 6.63Z",
    fill: "url(#paint1_linear_239_370)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.73 6.63L15.33 6.85C15.33 5.76 15.55 4.67 15.98 3.8H18.38C17.95 4.67 17.73 5.54 17.73 6.63Z",
    fill: "url(#paint2_linear_239_370)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.38 3.8H15.98C16.42 3.15 16.85 2.49 17.29 2.06H19.69C19.25 2.49 18.82 2.93 18.38 3.8Z",
    fill: "url(#paint3_linear_239_370)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6899 1.84H17.2899C18.1599 0.970001 19.2499 0.530001 20.5599 0.530001H22.9599C21.6499 0.530001 20.5599 1.19 19.6899 1.84Z",
    fill: "url(#paint4_linear_239_370)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.47 70.23H17.08L15.33 6.85L17.73 6.63L19.47 70.23Z",
    fill: "url(#paint5_linear_239_370)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0999 75.84L22.7099 75.92C19.8799 76.01 17.3999 73.48 17.0699 70.22L19.4599 70.14C19.7999 73.61 22.2799 76.15 25.0999 75.84Z",
    fill: "url(#paint6_linear_239_370)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0999 75.84L22.7099 75.92C19.8799 76.01 17.3999 73.48 17.0699 70.22L19.4599 70.14C19.7999 73.61 22.2799 76.15 25.0999 75.84Z",
    fill: "url(#paint7_linear_239_370)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0999 75.84L22.7099 75.92C19.8799 76.01 17.3999 73.48 17.0699 70.22L19.4599 70.14C19.7999 73.61 22.2799 76.15 25.0999 75.84Z",
    fill: "url(#paint8_linear_239_370)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0399 12.51V14.69L36.0199 14.91L35.8099 12.73L46.0399 12.51Z",
    fill: "#B7B7B7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.54 12.08C33.41 12.08 34.28 12.95 34.28 14.04L34.5 22.53C34.5 23.62 33.63 24.49 32.76 24.49L24.05 24.71C23.18 24.71 22.31 23.84 22.31 22.75L21.87 14.26C21.87 13.17 22.74 12.3 23.61 12.3L32.54 12.08Z",
    fill: "#F6A091"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2199 8.81L49.5299 65.65L21.2199 66.3L19.9099 9.46L48.2199 8.81ZM47.7899 60.21L47.1399 37.78L22.2999 38.43L22.9499 60.86L47.7899 60.21ZM21.8699 14.25L22.0899 22.74C22.0899 23.83 22.9599 24.7 23.8299 24.7L32.7599 24.48C33.6299 24.48 34.4999 23.61 34.4999 22.52L34.2799 14.03C34.2799 12.94 33.4099 12.07 32.5399 12.07L23.6099 12.29C22.7399 12.29 21.8699 13.16 21.8699 14.25ZM47.5699 34.73V32.77L22.5199 33.42V35.38L47.5699 34.73ZM47.3499 31.02V29.06L22.2999 29.72V31.68L47.3499 31.02ZM36.0199 16.65V18.61L46.0399 18.39V16.43L36.0199 16.65ZM35.8099 12.95V14.91L45.8299 14.69V12.73L35.8099 12.95Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0399 16.43V18.39L36.0199 18.61V16.65L46.0399 16.43Z",
    fill: "#B7B7B7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5399 2.29C35.8399 2.29 36.1399 2.59 36.1399 2.89C36.1399 3.19 35.8399 3.49 35.5399 3.49C35.2399 3.49 34.9399 3.19 34.9399 2.89C34.9399 2.59 34.9399 2.29 35.5399 2.29Z",
    fill: "#031570"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M37.89 4.9C38.12 4.9 38.12 5.22 38.12 5.54C38.12 5.86 37.89 6.18 37.89 6.18H32.7C32.47 6.18 32.47 5.86 32.47 5.54C32.47 5.22 32.7 4.9 32.7 4.9H37.89Z",
    fill: "#031570"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.81 67.61C37.12 67.61 38.21 68.7 38.21 70.22C38.21 71.74 37.12 72.83 36.03 72.83C34.72 72.83 33.63 71.74 33.63 70.22C33.41 68.92 34.5 67.83 35.81 67.61Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 4.54C30.58 4.54 31.24 4.87 31.24 5.53C31.24 6.19 30.91 6.19 30.58 6.19C30.25 6.19 29.59 5.86 29.59 5.2C29.59 4.54 29.92 4.54 30.25 4.54Z",
    fill: "#031570"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1299 37.78L47.7899 60.21L22.9599 60.86L22.5199 38.21L47.1299 37.78Z",
    fill: "#B7B7B7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.74 0.1C47.57 0.1 50.18 2.71 50.18 5.98L51.7 69.36C51.7 72.63 49.52 75.46 46.47 75.46L24.7 75.89C21.87 75.89 19.47 73.28 19.26 70.01L17.73 6.63C17.73 3.36 19.91 0.53 22.74 0.53L44.74 0.1ZM49.75 65.87L48.22 8.59L19.69 9.24L21 66.52L49.75 65.87ZM36.02 73.28C37.33 73.28 38.42 71.97 38.42 70.45C38.42 68.93 37.33 67.62 35.81 67.62C34.5 67.62 33.41 68.93 33.41 70.45C33.41 71.97 34.5 73.28 36.02 73.28ZM32.76 5.11C32.54 5.11 32.54 5.33 32.54 5.55C32.54 5.77 32.76 5.99 32.76 5.99H37.77C37.99 5.99 37.99 5.77 37.99 5.55C37.99 5.33 37.77 5.11 37.77 5.11H32.76ZM30.14 4.67C29.92 4.67 29.7 4.89 29.7 5.32C29.7 5.75 29.92 5.97 30.35 5.97C30.78 5.97 30.79 5.75 30.79 5.32C30.8 5.11 30.58 4.67 30.14 4.67ZM35.37 2.49C35.15 2.49 34.93 2.71 34.93 2.93C34.93 3.15 35.15 3.37 35.37 3.37C35.59 3.37 35.81 3.15 35.81 2.93C35.81 2.71 35.59 2.49 35.37 2.49Z",
    fill: "url(#paint9_linear_239_370)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3499 28.85V31.02L22.2999 31.46V29.5L47.3499 28.85Z",
    fill: "#B7B7B7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3499 32.55L47.5699 34.73L22.2999 35.16V33.2L47.3499 32.55Z",
    fill: "#B7B7B7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_370",
    x1: -4.18874,
    y1: 26.7721,
    x2: 35.3891,
    y2: -14.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_370",
    x1: -4.18874,
    y1: 26.7721,
    x2: 35.3891,
    y2: -14.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_239_370",
    x1: -4.07824,
    y1: 26.8787,
    x2: 35.4995,
    y2: -14.0724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_239_370",
    x1: -4.71453,
    y1: 26.2639,
    x2: 34.8634,
    y2: -14.6874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_239_370",
    x1: -4.40268,
    y1: 26.5654,
    x2: 35.1752,
    y2: -14.3858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_239_370",
    x1: 12.8549,
    y1: 43.2441,
    x2: 52.4328,
    y2: 2.29281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_239_370",
    x1: 31.7208,
    y1: 61.268,
    x2: 69.9274,
    y2: 19.0311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_239_370",
    x1: 31.7208,
    y1: 61.268,
    x2: 69.9274,
    y2: 19.0311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_239_370",
    x1: 31.7208,
    y1: 61.268,
    x2: 69.9274,
    y2: 19.0311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_239_370",
    x1: 10.8588,
    y1: 58.9185,
    x2: 53.8074,
    y2: 21.2135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949,
    stopColor: "#01193D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    stopColor: "#011E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3455,
    stopColor: "#012C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "#014270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#006197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8782,
    stopColor: "#0089C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6EC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService4);
export default __webpack_public_path__ + "static/media/service4.73603d161aaae1061697e657775376e1.svg";
export { ForwardRef as ReactComponent };